import { Component } from '@angular/core';
import { BaseTemplate } from '../../templates/base-template/base-template';
import { StepperCircleProgress } from '../../components/stepper-circle-progress/stepper-circle-progress';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-disconnected-page',
  imports: [BaseTemplate, StepperCircleProgress, TranslateModule],
  templateUrl: './disconnected-page.html',
  styleUrl: './disconnected-page.scss',
})
export class DisconnectedPage {}
